import flavia04 from '../images/flavia04.jpg'
import { PalmTree, Landmark, Globe2 } from 'lucide-react'

function Contact() {
	const handleSubmit = (e) => {
		e.preventDefault()
		// Handle form submission
	}

	return (
		<div className='container mx-auto px-4 py-8'>
			<div className='max-w-4xl mx-auto'>
				<h1 className='text-5xl font-bold mb-8'>Contact</h1>

				<div className='grid grid-cols-1 md:grid-cols-2 gap-12'>
					<div>
						<h2 className='text-3xl font-serif mb-4'>Get in Touch</h2>
						<p className='text-piano-black/80 mb-6'>
							For bookings, collaborations, or any inquiries, please don't hesitate to
							reach out to me.
						</p>

						<div className='space-y-4 text-piano-black/80'>
							<p>
								<strong className='block'>E-Mail:</strong>
								flaviak012@gmail.com
							</p>

							<p>
								<strong className='block'>Instagram:</strong>
								<a
									href='https://www.instagram.com/flav_kaa'
									target='_blank'
									rel='noopener noreferrer'
									className='text-piano-black hover:underline'>
									@flav_kaa
								</a>
							</p>

							{/* <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium mb-2">Name</label>
                <input
                  type="text"
                  id="name"
                  className="w-full px-4 py-2 border border-piano-black/20 rounded focus:outline-none focus:border-piano-black"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-2">Email</label>
                <input
                  type="email"
                  id="email"
                  className="w-full px-4 py-2 border border-piano-black/20 rounded focus:outline-none focus:border-piano-black"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium mb-2">Message</label>
                <textarea
                  id="message"
                  rows="5"
                  className="w-full px-4 py-2 border border-piano-black/20 rounded focus:outline-none focus:border-piano-black"
                  required
                ></textarea>
              </div>
              
              <button type="submit" className="btn btn-primary">Send Message</button>
            </form> */}
						</div>

						{/* <div>
            <h2 className="text-3xl font-serif mb-4">Contact Information</h2>
            <div className="space-y-4 text-piano-black/80">
              <p>
                <strong className="block">Management:</strong>
                Classical Artists Management<br />
                contact@example.com
              </p>
              
              <p>
                <strong className="block">Booking:</strong>
                booking@example.com
              </p>
              
              <p>
                <strong className="block">Instagram:</strong>
                <a href="https://www.instagram.com/flaviak.05" target="_blank" rel="noopener noreferrer" className="text-piano-black hover:underline">
                  @flaviak.05
                </a>
              </p>
            </div> */}

						<div className='mt-8'>
							<h3 className='text-2xl font-serif mb-4'>Location</h3>
							<p className='text-piano-black/80 gap-1 flex flex-col'>
								<span className='flex items-center'>
									<Landmark className='w-5 h-5 mr-2' aria-hidden />
									Born in Havana, Cuba
									<br />
								</span>
								<span className='flex items-center'>
									<svg
										className='w-5 h-5 mr-2'
										fill='none'
										stroke='currentColor'
										viewBox='0 0 24 24'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth='2'
											d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'></path>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth='2'
											d='M15 11a3 3 0 11-6 0 3 3 0 016 0z'></path>
									</svg>
									Currently based in Phnom Penh, Cambodia
									<br />
								</span>
								<span className='flex items-center'>
									<svg
										className='w-5 h-5 mr-2'
										fill='none'
										stroke='currentColor'
										viewBox='0 0 24 24'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth='2'
											d='M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z'></path>
									</svg>
									Available for performances worldwide
								</span>
							</p>
						</div>
					</div>
				</div>

				<div className='mt-12 mb-2'>
					<img
						src={flavia04}
						alt='Flavia Karla Amado León'
						className='w-full rounded-lg shadow-2xl'
					/>
				</div>
			</div>
		</div>
	)
}

export default Contact
